<template>
  <div>
    <Echart :options="options" id="bar" height="480px" width="1200px"></Echart>
  </div>
</template>

<script>
import Echart from "@/common/echart";
export default {
  data() {
    return {
      options: {},
    };
  },
  components: {
    Echart,
  },
  props: {
    cdata: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    cdata: {
      handler() {
        this.options = {

          title: {
            text: "Referer of a Website",
            subtext: "Fake Data",
            left: "center",
          },
          tooltip: {
            trigger: "item",
          },
          // color: ['#3DBCBE', '#3254DD','#2B8EF3','#BEE5FB','#3CD495'], // 自定义颜色范围
          legend: {
            top: "center",
            left: "right",
            orient: "vertical",
            textStyle: {
              fontSize: 12,
              color: "#1D2129",
            },
          },
          series: [
            {
              name: "Access From",
              type: "pie",
              radius: ["40%", "70%"],
              avoidLabelOverlap: false,
              itemStyle: {
                borderRadius: 10,
                borderColor: "#fff",
                borderWidth: 2,
              },
            
              emphasis: {
                label: {
                  show: true,
                  fontSize: 24,
                  fontWeight: "bold",
                },
              },
              
              data: [
                { value: 1048, name: "Search Engine" },
                { value: 735, name: "Direct" },
                { value: 580, name: "Email" },
                { value: 484, name: "Union Ads" },
                { value: 300, name: "Video Ads" },
              ],
            },
          ],
        };
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>
